import { Component } from '@opten/compiler/metadata/component';
import toggleClass from '@opten/dom/toggle-class';

@Component({ className: 'js-toggle-password-visiblity' })
export class PasswordVisibilityToggle {
	private input: HTMLInputElement;
	constructor(private element: HTMLElement) {
		this.input = this.element.parentElement.querySelector('input[type="password"]');
		this.element.addEventListener('click', () => this.toggleVisibility());
	}

	private toggleVisibility() {
		toggleClass(this.element, 'is-active');
		this.input.type = this.input.type === 'password' ? 'type' : 'password';
	}
}
